export const scrollIntoView = (id: string | undefined) => {
  if (!id) {
    return;
  }
  const element =
    document.getElementById(id) || document.getElementsByName(id)[0];
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

interface ScrollOptions extends ScrollToOptions {
  delay?: number;
}

export const scrollTop = (
  options: ScrollOptions = { top: 0, behavior: 'smooth', delay: 0 },
) => {
  const { delay, ...scrollToOptions } = options;
  // wrapped in setTimeout to ensure it works on mobile screens
  setTimeout(() => window.scrollTo(scrollToOptions), delay);
};
